<template>
  <div class="com-copyright">
    <div class="mod-box">
      <div class="fonter-menu">
        <a class="item" href="/">首页<span class="border-l">|</span></a>
        <a class="item" href="javascript:void(0)">诚聘英才<span class="border-l">|</span></a>
        <a class="item" href="javascript:void(0)">合作及洽谈<span class="border-l">|</span></a>
        <a class="item" href="/about/contact">联系我们<span class="border-l">|</span></a>
        <a class="item" href="/about/about">关于我们</a>
      </div>
      <p>
        Copyright © 2019-2020 ourchoice.cn, All rights reserved. 佛山市纵购电子商务有限公司 |
        <a target="_blank" href="http://beian.miit.gov.cn" rel="nofollow" style="color: #fff"
          >粤ICP备14093582号</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComCopyright'
}
</script>

<style lang="postcss">
.com-copyright {
  text-align: center;
  font-size: 12px;
  background-color: #666666;
  color: #fff;
  .mod-box {
    width: 1180px;
    color: #fff;
  }
  .fonter-menu {
    margin-bottom: 10px;
    .item {
      display: inline-block;
      color: #fff;
      .border-l {
        margin: 0 6px;
      }
    }
  }
}
</style>
